import { Injectable, inject } from '@angular/core';
import { GeneralConfigService, User, UserService } from '@inera/common';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DefaultRouteGuard {
  private userService = inject(UserService);
  private configService = inject(GeneralConfigService);

  private user: User;
  private secured = true;
  private secured$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor() {
    this.userService.connect().subscribe(user => {
      this.user = user;
    });
    this.configService.getConfig().subscribe(config => {
      this.secured = config.secured;
      this.secured$.next(config.secured);
    });

    this.secured$.subscribe(value => {
      if (!value) {
        this.userService.getUser().subscribe(user => {
          this.user = user;
        });
      }
    });
  }

  public canActivate(): Observable<boolean> {
    if (!this.secured) {
      return of(true);
    }
    return this.userService.getUser().pipe(
      switchMap(user => {
        if (user) {
          return of(true);
        } else {
          return of(false);
        }
      })
    );
  }

  public checkIfAuthorizedWithRoles(roles: string[]): boolean {
    const systemRoles = new Set(
      Object.values(this.user?.privileges).flatMap(roleSet => {
        return roleSet.name;
      })
    );

    if (roles.some(role => systemRoles?.has(role))) {
      return true;
    }

    return false;
  }

  public checkIfAuthorizedWithAnyRoles(): boolean {
    return this.user?.privileges != null && this.user?.privileges.length > 0;
  }

  public isLoggedIn(): boolean {
    if (!this.secured) {
      return true;
    }
    if (this.user) {
      return true;
    } else {
      return false;
    }
  }
}
